import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { Flex } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'

import type { NotificationType } from '../../types/notificiation-types'

const StCard = styled(Flex)`
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
`

const StIconContainer = styled.div<{ type: NotificationType }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;

  ${({ theme }) => `
    border: 1px solid #D9DCE0;
    width: ${theme.UI.SpacingPx.Space11};
    height: ${theme.UI.SpacingPx.Space11};
  `}
`

const StIcon = styled(FontAwesomeIcon)`
  ${({ theme }) => `
    height: ${theme.UI.SpacingPx.Space5};
    color: ${theme.Colors.Category.Message};
  `}
`

const StDotContainer = styled.div`
  position: absolute;
  top: 2px;
  left: 2px;
`

const StDot = styled.div`
  ${({ color }) => `
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${color};
  `}
`

const StDescription = styled(Span)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StDate = styled(Span)`
  font-weight: 400;
  whitespace: nowrap;
  text-align: right;
  min-width: 80px;
  margin: 0;
  flex-shrink: 0;
`

export { StCard, StDate, StDescription, StDot, StDotContainer, StIcon, StIconContainer }
